import { render, staticRenderFns } from "./AppButtonCancel.vue?vue&type=template&id=525d6473&scoped=true&"
import script from "./AppButtonCancel.vue?vue&type=script&lang=js&"
export * from "./AppButtonCancel.vue?vue&type=script&lang=js&"
import style0 from "./AppButtonCancel.vue?vue&type=style&index=0&id=525d6473&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525d6473",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
